/* eslint-disable jsx-a11y/no-static-element-interactions */
import Button from '@/components/Button';
import { MapPinIcon } from '@heroicons/react/24/solid';
import { SelectForm } from './Form';
import { PlusCircleIcon } from '@heroicons/react/20/solid';
import { Input } from '@/components/ui/input';
import { useProfileInfo } from './useProfileInfo';
import classNames from 'classnames';

export default function ProfileInfo() {
  const {
    user,
    isEditing,
    response,
    isLoading,
    forename,
    surname,
    fileRef,
    location,
    profile,
    sourcePhoto,
    page,
    register,
    onClickProfile,
    onClickProfilePicture,
    onChangeFile,
    onSaveChanges,
    convertDate,
  } = useProfileInfo();

  const { memberSinceTitle, editYourInfoCta, saveYourChangesCta, forenamePlaceholder, surnamePlaceholder } =
    page?.profileInfoSection || {};

  const renderViewState = () => {
    return (
      <div className=" col-span-6 flex flex-col items-start gap-1">
        <h1 className=" text-sh-md font-bold">
          {forename || user?.forename || 'Guest'} {surname || user?.surname}
        </h1>
        <p className=" !text-sh-sm">{profile || '' || user?.profile?.toString() || ''}</p>
        <p className=" !mt-0 !text-sh-sm">
          {memberSinceTitle} {convertDate(user?.createdAt)}
        </p>
        <div className="mb-5 flex items-start gap-1">
          <MapPinIcon className=" mt-1 h-5 w-5" />
          <p className=" !text-sh-sm">{location || user?.location}</p>
        </div>
      </div>
    );
  };

  const renderFormState = () => {
    return (
      <div className="mb-5 flex flex-col items-start gap-5">
        <SelectForm response={{ ...response }} onClickProfile={onClickProfile} defaultValues={{ role: profile }} />
        <div className="w-full md:w-2/3">
          <Input type="text" placeholder={forenamePlaceholder} {...register('forename')} />
        </div>
        <div className="w-full md:w-2/3">
          <Input type="text" placeholder={surnamePlaceholder} {...register('surname')} />
        </div>
      </div>
    );
  };

  return (
    <div className="mt-sh-30 flex flex-col gap-sh-15 md:flex-row ">
      <div className="ju relative flex cursor-pointer">
        <div
          className={classNames(
            'relative flex h-48 w-48 cursor-auto items-center justify-center rounded-full text-sh-80-88 font-bold uppercase text-black-100 shadow-[0_0.72px_2.88px_rgba(0,0,0,0.25)]',
            {
              'border-[4px] border-white bg-gradient-to-br from-[#B7DFFA] to-[#CFF6D8]': !sourcePhoto,
            },
          )}>
          {`${user?.forename ? user?.forename?.toString()[0] : ''}${user?.surname ? user?.surname?.toString()[0] : ''}`}
          {`${!user?.forename && !user?.surname ? 'G' : ''}`}
          {sourcePhoto && (
            <img
              className="absolute h-full w-full rounded-full object-cover object-center"
              src={sourcePhoto}
              alt="profile"
            />
          )}
        </div>
        {isEditing && (
          <>
            <input
              type="file"
              ref={fileRef}
              accept="image/*"
              onChange={onChangeFile}
              className="absolute inset-0 h-48 w-48 cursor-pointer rounded-full opacity-0"
            />
            <div
              className="absolute inset-0 h-48 w-48 rounded-full bg-black opacity-50"
              onClick={onClickProfilePicture}>
              <PlusCircleIcon className="absolute left-1/2 top-[50%] h-6 w-6 -translate-x-1/2 -translate-y-1/2 transform font-bold text-white md:left-1/2 md:top-[50%]" />
            </div>
          </>
        )}
      </div>
      <div className="w-full">
        {isEditing ? renderFormState() : renderViewState()}
        <Button theme="solid" onClick={onSaveChanges} loading={isLoading}>
          {!isEditing ? editYourInfoCta : saveYourChangesCta}
        </Button>
      </div>
    </div>
  );
}
